export default __webpack_public_path__ + "static/media/640_dummy2016-beauty02-mobile-de.61f97b89.png";